import React from "react"

export default () => <div>'Sup ZEIT!</div>
